import Swal from 'sweetalert2';

const sweetAlert = async (icon, title, text) => {
  return Swal.fire({
    icon: icon,
    title: title,
    text: text,
  });
};

export default sweetAlert;
